import dayjs from "dayjs";

export const BlogTypeAndDate = ({
  type,
  date,
}: {
  type?: string;
  date: string;
}) => {
  return (
    <aside className="flex items-center gap-12 text-14-20">
      <dt className="sr-only">Blog post type</dt>
      <span className="font-bold text-blue-500 dark:text-yellow-500">
        {type || "Blog"}
      </span>

      <div className="h-4 w-4 rounded-full bg-gray-300 dark:bg-gray-600" />

      <dt className="sr-only">Published on</dt>
      <dd>
        <time className="text-gray-800 dark:text-gray-500" dateTime={date}>
          {dayjs(date).format("MMMM D, YYYY")}
        </time>
      </dd>
    </aside>
  );
};
